import React, { useState } from 'react'
import styled from 'styled-components'
import { TableUtils } from 'submodules/nerit-framework-ui/common/components/table/utils/TableUtils'
import { ButtonGroupCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonGroupCP'
import { useFormStateManager } from 'submodules/nerit-framework-ui/common/form-state-manager/UseFormStateManager'
import { MatrixFiltersFormModel } from 'modules/collection-performance/components/matrix/filters-matrix/inner/MatrixFiltersFormModel'
import { FiltersMatrixCP } from 'modules/collection-performance/components/matrix/filters-matrix/FiltersMatrixCP'
import { TableMatrixCP } from 'modules/collection-performance/components/matrix/table-matrix/TableMatrixCP'
import { ButtonModalMatrixCP } from 'modules/collection-performance/components/matrix/button-modal-matrix/ButtonModalMatrixCP'

/**
 * Aba de administracao de Matrizes (agrupamentos de pontos) na Tela 3.1.
 */
export function TabMatrixCP(): JSX.Element {

    const [formModel] = useState<MatrixFiltersFormModel>(new MatrixFiltersFormModel())
    const formStateManager = useFormStateManager(formModel)

    const [shouldLoadData, setShouldLoadData] = useState<number>(TableUtils.getReloadNumber())

    return (
        <>
            <TopBarSCP>
                <ButtonGroupCP mode={'separeted'}>
                    <ButtonModalMatrixCP onSave={() => setShouldLoadData(TableUtils.getReloadNumber())}/>
                </ButtonGroupCP>
            </TopBarSCP>

            <FiltersMatrixCP
                formStateManager={formStateManager}
                onFilter={() => setShouldLoadData(TableUtils.getReloadNumber())}
            />

            <TableMatrixCP
                filters={MatrixFiltersFormModel.formatDto(formStateManager)}
                shouldLoadData={shouldLoadData}
            />
        </>
    )
}

const TopBarSCP = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
`
